/** Style2 cards: swatches, variant selection, add-to-cart */
(function () {
  const swatchCache = new Map();

  function getCustomField(sku, key) {
    const field = sku.customFields?.find((f) => f.key === key);
    return field?.value ?? '';
  }

  function getSizeFieldKey(skus, product) {
    const sizeValues = new Set();
    const colorValues = new Set();
    const colorName = (product?.colorName || '').toLowerCase();

    (skus || []).forEach((sku) => {
      const s = getCustomField(sku, 'size');
      const c = getCustomField(sku, 'color');
      if (s && s.toLowerCase() !== colorName) sizeValues.add(s);
      if (c) colorValues.add(c);
    });

    return sizeValues.size >= colorValues.size && sizeValues.size > 0 ? 'size' : 'color';
  }

  function skusToVariants(skus, product) {
    const sizeKey = getSizeFieldKey(skus, product);
    const colorKey = sizeKey === 'size' ? 'color' : 'size';

    return (skus || []).map((sku) => ({
      id: sku.id,
      available: sku.availability === 'InStock',
      option1: getCustomField(sku, colorKey) || product?.colorName || '',
      option2: getCustomField(sku, sizeKey) || getCustomField(sku, colorKey),
      option3: null
    }));
  }

  function fetchSwatchProducts(url) {
    if (swatchCache.has(url)) return Promise.resolve(swatchCache.get(url));
    return fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector('[js-products-json]');
        const products = el ? JSON.parse(el.innerHTML) : [];
        swatchCache.set(url, products);
        return products;
      });
  }

  function buildSizeOptions(product, variants, form, sectionId, productId) {
    const sizeKey = getSizeFieldKey(product.skus, product);
    const colorKey = sizeKey === 'size' ? 'color' : 'size';
    const colorName = (product.colorName || '').toLowerCase();
    const seen = new Set();
    const sizes = [];

    product.skus.forEach((sku) => {
      let val = getCustomField(sku, sizeKey) || getCustomField(sku, colorKey);
      if (!val || seen.has(val) || val.toLowerCase() === colorName) return;
      seen.add(val);
      sizes.push({ size: val, sku });
    });

    return sizes
      .map(({ size, sku }) => {
        const variant = variants.find((v) => v.id === sku.id);
        const available = variant?.available ?? false;
        const id = `ProductSelect-option-${sectionId}-${productId}-size-${String(size).replace(/\s/g, '-')}`;
        const disabled = !available ? ' disabled' : '';
        const disableClass = !available ? ' js-variant-disable' : '';
        return `
          <input type="radio" data-index="option2" name="size" id="${id}" class="single-option-selector-${sectionId} single-option-selector__radio card-option-input${disableClass}" value="${String(size).replace(/"/g, '&quot;')}" form="${form.id}" data-option-value-id="${sku.id}" data-available="${available}"${disabled}>
          <label for="${id}" class="nosto-size"${disabled ? ' disabled="disabled"' : ''} skuid="${sku.id}">${size}</label>
        `;
      })
      .join('');
  }

  function switchProduct(card, product, state) {
    const form = card.querySelector('.card-product-form');
    const variantInput = form?.querySelector('input[name="id"]');
    const submitBtn = form?.querySelector('button[type="submit"]');
    if (!form || !variantInput || !state) return;

    const sectionId = card.dataset.sectionId || '';
    const productId = String(product.productId);
    const variants = skusToVariants(product.skus, product);
    state.setVariants(variants);

    if (card.querySelector('.js-card-main-img') && product.imageUrl) {
      card.querySelector('.js-card-main-img').src = product.imageUrl;
      card.querySelector('.js-card-main-img').alt = product.name || '';
    }
    const hoverImg = card.querySelector('.js-card-hover-img');
    if (hoverImg) {
      hoverImg.src = product.alternateImageUrls?.[0] || product.imageUrl || '';
    }

    const productLink = card.querySelector('.js-card-product-link');
    const nameLink = card.querySelector('.js-card-product-name-link');
    if (product.url) {
      if (productLink) productLink.href = product.url;
      if (nameLink) {
        nameLink.href = product.url;
        nameLink.textContent = product.name || '';
      }
    }
    const quickshopBtn = card.querySelector('.js-card-quickshop-btn');
    if (quickshopBtn && product.url) quickshopBtn.dataset.productUrl = product.url;

    const priceEl = card.querySelector('.js-card-price');
    if (priceEl) {
      const hasCompare = product.listPrice && parseFloat(product.listPrice) > parseFloat(product.price);
      priceEl.innerHTML = hasCompare && product.listPriceFormatted
        ? `<span class="price price--compare">${product.listPriceFormatted}</span> <span class="price price--sale">${product.priceFormatted || product.price}</span>`
        : `<span class="price">${product.priceFormatted || product.price}</span>`;
    }

    card.setAttribute('prodid', productId);
    const variantsScript = card.querySelector('.js-card-variants-script');
    if (variantsScript) variantsScript.textContent = JSON.stringify(variants);

    const sizeFieldset = card.querySelector('.js-card-size-fieldset');
    if (sizeFieldset && product.skus?.length) {
      sizeFieldset.innerHTML = buildSizeOptions(product, variants, form, sectionId, productId);
      sizeFieldset.querySelectorAll('.card-option-input').forEach((input) => {
        input.addEventListener('change', () => state.updateVariant());
      });
    }

    variantInput.value = '';
    variantInput.disabled = true;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-disabled', 'true');
      const span = submitBtn.querySelector('span');
      if (span) span.textContent = card.dataset.addText || 'Add to cart';
    }
  }

  function swapSwatchCurrent(container, clickedBtn, product, products) {
    const oldCurrent = container.querySelector('.product__swatch-link--current');
    if (oldCurrent && oldCurrent !== clickedBtn) {
      const idMatch = oldCurrent.id?.match(/swatch-(\d+)-/);
      const oldIdx = idMatch ? products.findIndex((p) => String(p.productId) === idMatch[1]) : -1;
      const newBtn = document.createElement('button');
      newBtn.type = 'button';
      newBtn.className = 'product__swatch-link';
      const oldLabel = oldCurrent.getAttribute('aria-label') || '';
      newBtn.setAttribute('aria-label', `Select color ${oldLabel}`);
      newBtn.dataset.productIndex = String(oldIdx >= 0 ? oldIdx : 0);
      newBtn.style.cssText = oldCurrent.style.cssText;
      newBtn.setAttribute('js-swatch-link', '');
      container.replaceChild(newBtn, oldCurrent);
    }
    const newDiv = document.createElement('div');
    newDiv.className = 'product__swatch-link product__swatch-link--current';
    newDiv.id = `swatch-${product.productId}-${(product.colorName || '').replace(/\s/g, '-')}`;
    newDiv.setAttribute('aria-label', product.colorName || product.name || '');
    newDiv.setAttribute('aria-current', 'true');
    newDiv.setAttribute('role', 'img');
    newDiv.style.cssText = clickedBtn.style.cssText;
    container.replaceChild(newDiv, clickedBtn);
  }

  function loadSwatchContainer(container) {
    const tag = container.dataset.tag;
    const handle = container.dataset.handle;
    if (!tag || container.dataset.loaded !== 'false') return;

    const root = window.Shopify?.routes?.root ?? '/';
    const url = `${root}collections/shop-all/${tag}?view=json`;

    container.setAttribute('aria-busy', 'true');
    fetchSwatchProducts(url)
        .then((products) => {
          container.dataset.loaded = 'true';
          container.removeAttribute('aria-busy');
          let markup = '';
          products.forEach((p, i) => {
            const colorImg = p.colorImg || 'no-image';
            const colorHex = p.colorHex || 'transparent';
            const bgColor = colorImg.includes('no-image') ? colorHex : '';
            const bgImage = colorImg.includes('no-image') ? '' : `url(${colorImg})`;
            const name = p.colorName || p.name || '';
            const safeName = (name || '').replace(/"/g, '&quot;');
            if (handle === p.handle) {
              markup += `<div class="product__swatch-link product__swatch-link--current" id="swatch-${p.productId}-${name.replace(/\s/g, '-')}" aria-label="${safeName}" aria-current="true" role="img" style="background-color:${bgColor};background-image:${bgImage};background-size:cover;"></div>`;
            } else {
              markup += `<button type="button" class="product__swatch-link" aria-label="Select color ${safeName}" data-product-index="${i}" style="background-color:${bgColor};background-image:${bgImage};background-size:cover;" js-swatch-link></button>`;
            }
          });
          container.innerHTML = markup;
          requestAnimationFrame(() => container.classList.add('is-loaded'));

          const makeHandler = (productsArr, cont) => (e) => {
            const btn = e.target.closest('[js-swatch-link]');
            if (!btn) return;
            e.preventDefault();
            const card = btn.closest('.product-card--style2');
            const state = card?.__variantState;
            const idx = parseInt(btn.dataset.productIndex, 10);
            const product = productsArr[idx];
            if (card && state && product) {
              switchProduct(card, product, state);
              swapSwatchCurrent(cont, btn, product, productsArr);
            }
          };
          container.addEventListener('click', makeHandler(products, container));
        })
        .catch(() => {
          container.dataset.loaded = 'true';
          container.removeAttribute('aria-busy');
        });
  }

  function initSwatchLinks() {
    const containers = document.querySelectorAll('.product-card--style2 [js-swatch-links-wrapper][data-loaded="false"]');
    if (!containers.length) return;

    const loadIfVisible = (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const container = entry.target;
        observer.unobserve(container);
        loadSwatchContainer(container);
      });
    };

    const observer = new IntersectionObserver(loadIfVisible, {
      rootMargin: '100px',
      threshold: 0.01
    });

    containers.forEach((container) => observer.observe(container));
  }

  function initVariantForms() {
    document.querySelectorAll('.product-card--style2 .card-product-form').forEach((form) => {
      const card = form.closest('.product-card--style2');
      if (!card || card.dataset.variantJsInit) return;
      card.dataset.variantJsInit = '1';

      const productId = card.getAttribute('prodid');
      const script = card.querySelector('.js-card-variants-script') || document.querySelector(`[data-product-variants-${productId}]`);
      if (!script) return;

      let variants;
      try {
        variants = JSON.parse(script.textContent);
      } catch {
        return;
      }

      const variantInput = form.querySelector('input[name="id"]');
      const submitBtn = form.querySelector('button[type="submit"]');

      function getSelectedOptions() {
        const opts = {};
        form.querySelectorAll('.single-option-radio').forEach((fs) => {
          const checked = fs.querySelector('input:checked');
          if (checked) opts[checked.dataset.index] = checked.value;
        });
        return opts;
      }

      function findVariant() {
        const selected = getSelectedOptions();
        const sizeFieldset = form.querySelector('.js-card-size-fieldset');
        if (sizeFieldset && !sizeFieldset.querySelector('input:checked:not(:disabled)')) return null;
        return variants.find((v) =>
          (!selected.option1 || v.option1 === selected.option1) &&
          (!selected.option2 || v.option2 === selected.option2) &&
          (!selected.option3 || v.option3 === selected.option3)
        );
      }

      function updateVariant() {
        const variant = findVariant();
        const addText = card.dataset.addText || 'Add to cart';
        const soldOutText = card.dataset.soldOutText || 'Sold out';
        if (variant) {
          variantInput.value = variant.id;
          variantInput.disabled = false;
          if (submitBtn) {
            submitBtn.disabled = !variant.available;
            submitBtn.setAttribute('aria-disabled', String(!variant.available));
            const span = submitBtn.querySelector('span');
            if (span) span.textContent = variant.available ? addText : soldOutText;
          }
        } else {
          variantInput.value = '';
          variantInput.disabled = true;
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.setAttribute('aria-disabled', 'true');
            const span = submitBtn.querySelector('span');
            if (span) span.textContent = addText;
          }
        }
      }

      card.__variantState = { setVariants: (v) => { variants = v; }, updateVariant };

      form.querySelectorAll('.card-option-input').forEach((input) => input.addEventListener('change', updateVariant));

      const sizeFieldset = form.querySelector('.js-card-size-fieldset');
      if (sizeFieldset) {
        sizeFieldset.addEventListener('click', (e) => {
          const label = e.target.closest('label[for]');
          if (label) {
            const radio = document.getElementById(label.getAttribute('for'));
            if (radio && !radio.disabled) radio.checked = true;
          }
          requestAnimationFrame(updateVariant);
        });
      }

      updateVariant();
    });
  }

  function init() {
    initVariantForms();
    initSwatchLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
